import { keyMirror } from 'ramda-extension';

export const deckCacheKeys = keyMirror({
	ALL_DECKS: null,
	SINGLE_DECK: null,
	PAGEABLE_DECKS: null,
	ALL_DECKS_BY_ID: null,
	PUBLISHED: null,
});
